export default {
    行情: "相場",
    了解最新行情和交易大数据: "最新の相場や取引ビッグデータを知る",
    热门榜: "人気ランキング",
    新币榜: "新札ランキング",
    涨幅榜: "上昇幅ランキング",
    热门合约: "ホットな契約",
    交易: "取り引き",
    现货交易: "現物取引",
    币币闪兑: "通貨フラッシュ、クイック取引",
    搜索: "検索けんさく",
    主流币: "主流通貨",
    热门: "人気がある",
    合约: "契約",
    永续: "永続",
    灵活杠杆: "柔軟なレバレッジ、高い収益性",
    金融业务: "金融業務",
    店铺展示: "店舗ディスプレイ",
    '门店编号': "店舗番号",
    '城市': "とし",
    '地址': "アドレス",
    'show1': '2030年までに、クロコダイルの提携店舗数は100000店に達する見込みだ。',
    'show2': 'どの店にも真実、独立したIDがあり、すべてが真実、有効、公開、透明！',
    'show3': '暗号化通貨×コミュニティサービス×提携ウィンウィン',
    'show4': 'Crocodile Exchange提携店計画・地元ビジネスの新たな生態づくり',
    优质项目起飞的地方: "良質なプロジェクトが離陸する場所",
    解锁潜质代币: "ロック解除潜在通貨",
    定期挖矿: "定期的に採掘する",
    更多个性化选择: "カスタマイズの詳細",
    暂无数据: "データが一時的にありません",
    探索数字资产的无限可能: "デジタル資産の無限の可能性を探る",
    更多下载选择: "ダウンロードの詳細",
    注册: "登録",
    开始: "スタート",
    "立即注册，免费创建自己的作品集！": "今すぐ登録して、無料で自分の作品集を作成します！",
    "布局未来，现在开始": "未来をレイアウトして、今から",
    邮箱: "メールアドレス/携帯電話",
    把握交易良机: "次の取引機会をつかむ",
    市场行情: "市況",
    "热门衍生品": "人気派生品",
    "热门代币": "人気のトークン",
    主流榜: "主流ランキング",
    现货新币榜: "現物新貨ランキング",
    合约新币榜: "契約新貨ランキング",
    交易对: "取引ペア",
    最新价: "最新価格",
    涨跌幅: "上昇幅",
    走势图: "トレンドマップ",
    成交量: "出来高",
    操作: "操作",
    待上币种: "保留中の通貨",
    上线时间: "オンライン時間",
    开盘倒计时: "オープンカウントダウン",
    已上币种: "前の通貨",
    下载应用: "Appのダウンロード",
    随时随地: "いつでもどこでも取引を開始",
    受千万用户信赖的加密货币交易所: "1000万人のユーザーに信頼される暗号通貨取引所",
    强大的交易体验: "強力な取引体験",
    提供多种加密货币交易: "多種の暗号化貨幣取引を提供し、現物、契約、荷為替などの多種の製品をカバーし、多様な投資需要を満たす",
    全天服务: "7*24時間サービス",
    提供全天候服务: "プロフェッショナルカスタマーサービスは24時間オンラインで、24時間365日サービスを提供し、いつでもユーザーの疑問に答えることができます。",
    安全合规: "セキュリティコンプライアンス",
    顶级安全风控体系: "トップレベルの安全風制御システム、多地域コンプライアンス運営、ユーザーの資産安全を全方位的に保護する。",
    全球化布局: "グローバル・レイアウト",
    值得全球用户信赖: "世界210+の国と地域をカバーし、世界中のユーザーに信頼され、いつでもどこでも暗号化された通貨取引に参加できるようにします。",
    多种币种: "複数通貨",
    全天交易量: "24時間取引量",
    多种选择: "複数選択",
    注册用户: "ユーザーの登録",
    "用户": "ユーザー",
    覆盖国家及地区: "国と地域をカバーする",
    立即开启您的加密货币交易之旅: "暗号化された通貨取引の旅を今すぐ開始",
    即刻开户: "すぐに口座を開く",
    自动创建账户: "メールアドレス/携帯電話番号登録ログイン後、自動的にアカウントを作成",
    钱包充值: "ウォレットチャージ",
    可随时为账户充值: "アカウントへのチャージはいつでも可能で、主流チャネルへの入金をサポートしています",
    开始交易: "取引開始",
    然后开始交易: "取引する現通貨ペアまたは契約を選択し、取引を開始します",
    关于我们: "私たちについて",
    关于: "について",
    使用者协议: "コンシューマプロトコル",
    隐私政策: "プライバシーポリシー",
    支持: "サポート",
    下载: "ダウンロード",
    帮助中心: "ヘルプセンター",
    买币: "貨幣を買う",
    数字货币计算器: "デジタル通貨計算機",
    购买: "購入する",
    联系我们: "連絡先",
    社区: "コミュニティ",
    搜寻: "シーク",
    此段落内的文章: "この段落内の記事",
    简介: "概要",
    更新于: "更新＃コウシン＃",
    我们的愿景: "私たちのビジョン",
    核心优势: "コアメリット",
    产品与服务: "製品とサービス",
    我们的使命: "私たちの使命",
    aboutText1: "Crocodile 取引所は世界をリードするデジタル資産取引プラットフォームであり、世界のユーザーに安全で効率的で透明な暗号通貨取引サービスを提供することに力を入れている。業界内の革新的なパイオニアとして、Crocodile は先進的なブロックチェーン技術と金融安全システムを採用し、ユーザーの資産安全を確保するとともに、スムーズで安定した取引体験を提供している。",
    aboutText2: "Crocodile 取引所のビジョンは、世界で最も信頼できるデジタル資産取引生態系を構築し、ユーザーに革新的でコンプライアンス、多元化された取引サービスを提供し、ブロックチェーン技術とデジタル金融の発展を推進することである。",
    aboutText3: "トップレベルの安全防護：銀行レベルの安全防護システムを採用し、多重暗号化技術と冷熱財布の分離メカニズムを採用し、ユーザーの資産の安全を保障する。",
    aboutText4: "効率的な仲介エンジン：Crocodile は世界をリードする仲介取引システムを持ち、超高速取引の実行をサポートし、取引の円滑な遅延がないことを確保する。",
    aboutText5: "多通貨サポート：ビットコイン（BTC）、イーサ坊（ETH）、USDTなどの多種の主流及び良質な革新型デジタル資産取引をサポートする。",
    aboutText6: "グローバルコンプライアンス：各国の金融規制を厳格に遵守し、取引コンプライアンスの透明性を確保し、ユーザーに合法的なコンプライアンスを提供するデジタル資産取引サービス。",
    aboutText7: "24/7プロフェッショナルカスタマーサービス：24時間365日の多言語カスタマーサポートを提供し、ユーザーが問題を迅速に解決し、取引体験を最適化するのを支援します。",
    aboutText8: "現物取引：主流の暗号化通貨取引ペアを提供し、低遅延、高流動性で、初心者と専門トレーダーに適している。",
    aboutText9: "契約取引：高レバレッジ、低滑り点、ユーザーの柔軟な取引戦略の実現を支援する。",
    aboutText10: "品質保証と財テク：多種の収益型製品を提供し、ユーザーの資産増値を実現するのを助ける。",
    aboutText11: "API取引：機構と量子化トレーダーに高性能APIインタフェースを提供し、専門取引の需要を満たす。",
    aboutText12: "Crocodile 取引所は常に「ユーザー至上、安全至上、革新駆動」の中核的価値観を堅持し、世界のデジタル資産トレーダーにワンストップソリューションを提供している。将来の金融システムはブロックチェーンによって駆動され、Crocodile は業界の発展を持続的に推進し、世界のユーザーにより公平で効率的で透明なデジタル金融サービスをもたらすと信じています。",
    aboutText13: "Crocodile 取引所、未来の金融を手に入れることができます！",
    已结束: "終了",
    分发总量: "配布合計",
    个人兑换限额: "個人換算限度額",
    最小投入量: "最小投入量",
    兑换价格: "為替相場",
    launchpad: "Crocodile Launchpadは、ユーザーが初期段階で人気のあるプロジェクトトークンを購入できるようにするための良質なブロックチェーンの新しいプロジェクトのための選択プラットフォームです。",
    launchpad1: "EchoLinkは、Solanaブロックチェーンに配備されたDePIN IoTデバイスのために設計されたブロックチェーン予言機である。それは独特な証明メカニズムを通じてキットの各種IoT装置をブリッジし、拡張し、それらの作業負荷を収集、測定、検証することによって、信頼できる資料報告を生成する。これらの資料は、ゼロ知識証明を使用して暗号化され、Oracleノードに送信され、各アプライアンス・ユニットが取得できる報酬を評価します。EchoLinkはまた、より多くのDePIN専用のインフラストラクチャを目指した包括的なソフトウェアSDKとハード設計の組み合わせを提供しています。",
    launchpad2: "ACGN Protocolは、AIによって駆動されるWeb 3 ACGN（アニメ、漫画、ゲーム、小説）クリエイターの生態系である。オープンソースクリエイター契約に基づく：ACGN Protocol，ユーザーは私たちのAIツールを利用してオリジナルIPから派生コンテンツを作成し、派生品とオリジナル間のNFTコンテンツネットワーク接続を促進し、ボトムアップACGNコンテンツ創作生態システムを構築することができます。",
    launchpad3: "MetaExpand，は、Universal Metaverse Expansion Protocolの略語（トークン名：UMM），汎用的な元宇宙拡張プロトコルです。MetaExpandは元宇宙生態の基礎インフラであり、公鍊と元宇宙応用の間の技術的ギャップを大幅に低減し、元宇宙応用開発に向けてより友好的なストレージ、通信、プライバシー、クロス鍊と取引の基礎プラグインと開発基準を提供し、開発者が基礎ブロックチェーンの技術的違いをあまり考慮する必要がないようにする。MetaExpandは、共通プラグインとしても高速開発の起点としても使用することができ、MetaExpandは他の主流公鎖と互換性があると位置づけ、そのためにエネルギーを与え、その元宇宙生態開発能力を拡張し、加速させる。",
    launchpad4: "PINSは、マルチロールプレイングを使用してプロット駆動のメタ宇宙を作成し、歴史や文化的属性をコミュニティに導入するコンテンツソーシャルネットワークです。PINSには無数のページがあり、それぞれのページは仮想世界に相当し、人々はさまざまな役割を果たし、さまざまな行為に参加することができます。",
    Launchpool1: "私のLaunchpool",
    Launchpool2: "Metaverse HQ（MVHQ）は、ゲーム向け、De-Fi、プロトコル、クリエイター、NFT/Memecoin社稷、および非中心化生態系のAI強化型タスクプロトコル。MVHQはチェーン上とチェーン下の奨励の共通ハブとなり、使用者に数百万ドルの価値を分配している。",
    Launchpool3: "REVOX.AIは無許可の機械学習インフラを通じてWeb 3の共有AIインターフェースを構築しており、中心化AI応用の開発と革新を賦与し、モジュール化インテリジェントエージェントの広範な応用を推進している。REVOXの旗艦スーパーアプリケーションであるWeb 3 GPT Lense、スマートウォレット、ReadON DAOアプリケーションは、世界中で2100万人以上のユーザーを誘致している。",
    Launchpool4: "Cellulaは、仮想ワークロード証明（vPOW）メカニズムを利用して、革新的なゲーム化発行方法を通じて公平な資産配分と流動性誘導を実現するプログラム可能なインセンティブ層です。このプロジェクトはBinance LabsとOKX Venturesに支持されている。CellulaのvPOWは「BitLife」エンティティに独自のハッシュ率を与え、ゲーム化された掘削プロセスに参加し、動的な励起を生み出すことができるようにしています。この革新的な掘削方法は適応性とプログラム可能性を導入し、Cellulaがこれまでにない公平な資産分配と流動性分配の導きを実現できるようにした--これはEVM互換ネットワークの真の創始である。",
    Launchpool5: "LBank Launchpoolへの参加方法",
    全部: "すべて",
    报名中: "申し込み中",
    预热中: "予熱中",
    待发放: "リリース保留中",
    标的币种: "標準通貨",
    一键报名: "ワンクリックで申し込む",
    选择您感兴趣的项目并报名: "興味のある項目を選んで応募してください",
    等待释放: "解放待ち",
    等待计算您将获得的代币数量: "取得するトークンの数の計算待ち",
    获得代币: "獲得トークン",
    前往现货账户查看获得的代币: "現物口座に行って獲得したトークンを調べる",
    locking1: "安定していて、収益が高くて、心がもっと安定しています！",
    locking2: "FLOKIを質押しトーケンを稼ぐ",
    立即登录: "今すぐログイン",
    项目名: "プロジェクト名",
    年化收益率: "年間収益率",
    结算日期: "決済日",
    锁仓天数: "ロック日数",
    锁仓进度: "倉庫ロックの進行状況",
    天: "日",
    我要支付: "私は支払います",
    我将收到: "受け取ります",
    购买数字货币: "デジタル通貨の購入",
    btc1: "このページには、人気のある100種類以上のデジタル通貨を必要なフランス通貨に変換できる、デジタル通貨とフランス通貨のリアルタイム為替レートが表示されています。また、お気に入りの通貨を使用可能なデジタル通貨資産に変換することもできます。",
    btc2: "上位50通貨のデジタル通貨とフランス通貨の為替レート",
    展开: "てんかい",
    收起: "やめる",
    数字货币: "デジタル通貨",
    轻松跟单: "簡単な荷為替、インテリジェントな取引",
    顶级带单员: "トップ・レベルの帯域管理者",
    全部带单员: "すべての帯域者",
    最高收益率: "最高収益率",
    获得最高收益率的带单员: "最高収益率を獲得した帯域者",
    今日最佳: "今日のベスト",
    最高收益: "最高益",
    赚取最高带单收益的带单员: "最も高い帯域単収益を稼ぐ帯域単員",
    新晋带单员: "新人帯単員",
    最低回撤: "最小ロールバック",
    交易风险最稳定的带单员: "取引リスクが最も安定している帯状者",
    最高跟随者收益: "最高フォロワー収益",
    带领跟随者获得最高收益的带单员: "フォロワーを最高の収益に導いた帯状者",
    综合排名: "総合ランキング",
    收益率: "収益率",
    胜率: "勝率",
    收益: "に利益を与える",
    跟随者收益: "フォロワー収益",
    最大回撤: "最大ロールバック",
    筛选: "フィルタリング",
    隐藏满员: "満員を隠す",
    更多: "その他",
    跟单: "について行く",
    空位提醒: "空席リマインダ",
    成为带单员: "帯状者になる",
    跟单教程: "荷為替教程",
    跟单周动态: "荷為替週動態",
    明星带单员: "スターベルト",
    产品更新与热门活动一览: "製品アップデートと人気イベント一覧",
    火箭团团长: "ロケット団団長",
    总收益: "総収益",
    copy1: "過去7日間で最も活躍した帯域員ランキング",
    copy2: "高収益、低リターンの新人帯域単員",
    help1: "資産凍結とは？",
    help2: "資産凍結とは、取引を行っている間にプロセスが完了しておらず、現在の資産は一時的にシステム管理されており、自由に使用できません。資産の損失や資産に異常があるわけではありません。ご安心ください。",
    help3: "先物取引のルールは何ですか。",
    help4: "現在の取引ペアの次の価格動向（上昇または下落）を予測することで取引に参加する。決算時には上昇幅や下落幅を計算せず、上昇幅や下落幅の利益だけを計算する。受け渡し時間によって決済される利益の割合が異なり、利益は取引インタフェースに正確に表示されます。",
    help5: "資産充填、現金化に変換が必要なUSDTの数は、どのように変換されますか？",
    help6: "資産のチャージ、現金化の金額は、チャージ、現金化に使用される通貨/USDTのリアルタイム価格の変動によって変わりますが、実際には資産に変化はありません。",
    help7: "取引パスワードを忘れたらどうする？",
    help8: "取引パスワードを忘れた場合は、【パーソナルセンター】の右上にある【セキュリティセンター】【取引パスワード】をクリックして変更することができます。具体的な手順は次の通りです。",
    help9: "1.携帯電話番号をバインドした場合、携帯電話番号の認証コードを取得する必要がある",
    help10: "2.メールボックスをバインドする場合は、メールボックスの認証コードを取得する必要があります",
    help11: "3.新規取引パスワードの記入",
    help12: "4.新しい取引パスワードの確認",
    help13: "5.【提出】をクリック",
    help14: "ログインパスワードを忘れたらどうする？",
    help15: "ログインパスワードを忘れた場合は、【ログインページ】【パスワードを忘れた？】でメールボックスまたは携帯電話の認証コードを取得し、新しいログインパスワードを設定できます。",
    help16: "どのようにアカウントのセキュリティを強化しますか？",
    help17: "アカウントのためにより複雑で安全なパスワードを作成し、個人情報を誰とも共有しないでください。",
    protocol1: "当サイトは外国為替及びデジタル資産の取引及び関連サービスに特化したプラットフォーム（以下「本サービス」又は「サービス」と略称する）である。本契約の便宜のため、本サイトは本契約において「デル」またはその他の第1人称用語を使用します。本契約の便宜のために、以下では「あなた」または他の二人称用語を使用します。本契約の便宜のために、私たちとあなたは本契約の中で「双方」と呼ばれ、私たちまたはあなたは単独で「一方」と呼ばれます。",
    protocol2: "重要なヒント：",
    protocol3: "ここでは特に注意しておきます：",
    protocol4: "デジタル資産自体は金融機関や会社、または当サイトから発行されません。",
    protocol5: "デジタル資産市場は新興で、未確認で、成長しない可能性があります。",
    protocol6: "デジタル資産は主に投機家に使用され、小売や商業市場での使用は相対的に少ない。それらは終日取引され、上昇・下落の制限はなく、価格は庄家や世界政府の政策の影響を受けやすく変動が大きい、",
    protocol7: "デジタル資産取引には大きなリスクがあり、ほとんどの人には適していません。この取引が一部またはすべての損失をもたらす可能性があることを理解し、理解してください。したがって、あなたが耐えられる損失の程度に基づいて取引金額を決定する必要があります。デジタル資産を売買する決定を下す前に、財務状態と上記のリスクを評価し、それによるすべての損失を負担するために、明確な判断を使用して慎重に検討してください。私たちはこれに対して何の責任も負いません。",
    protocol8: "お知らせ：",
    protocol9: "このWebサイトは、デジタル資産情報を取得し、取引先を探し、デジタル資産について交渉し、取引する場所にすぎないことを理解しています。",
    protocol10: "インターネットベースの取引システムを使用することには、ソフトウェア、ハードウェア、およびインターネット接続障害を含むが、これらに限定されないリスクもある。インターネットの信頼性と可用性を制御することができないため、歪み、遅延、接続障害には一切責任を負いません。",
    protocol11: "一、総則",
    protocol12: "「ユーザー・プロトコル」（以下「本プロトコル」または「本条項」と略称する）は、本文、「プライバシー条項」、「あなたの顧客と反マネーロンダリング政策を理解する」、および本サイトがすでに発表されているか、将来発表される可能性のある各種規則、声明、説明などから構成されている。",
    protocol13: "当サイトが提供するサービスを使用する前に、本契約書をよくお読みください。本契約書および/またはその変更に同意しない場合は、直ちに本サイトが提供するサービスの使用を停止するか、本サイトへのログインを停止してください。本サイトにログインしたり、本サイトのサービスを使用したり、その他の類似した動作を使用したりすると、本契約の変更をいつでも行うことを含め、本契約のすべての内容を理解し、完全に同意したことになります。",
    protocol14: "当サイトの会員になると、会員アカウントと相応のパスワードを取得し、そのアカウントとパスワードを適切に保管する責任があります。アカウントの下で行われたすべてのアクティビティとイベントに法的責任を負います。",
    protocol15: "このWebサイトで提供されているサービスと機能を登録して使用することで、お客様は読み取り、理解し、次のものとみなされます。",
    protocol16: "本契約のすべての条項と条件を受け入れます。",
    protocol17: "満18歳であることを確認するか、適用される法律によって契約を締結する法定年齢があることを確認します。",
    protocol18: "取引所が関与するデジタル資産が合法的に取得され、所有されていることを保証します。",
    protocol19: "あなたは、自分自身の取引または非取引行為、および任意の収益または損失に対してすべての責任を負うことに同意します。",
    protocol20: "登録時に提供された情報が実際に正確であることを確認します。",
    protocol21: "二、協議書の改訂",
    protocol22: "デルは、個別に通知することなく、本契約を随時変更し、Webサイトに公開する権利を保持しています。",
    protocol23: "三、登録",
    protocol24: "登録資格",
    protocol25: "登録手続きを完了したり、本サイトが提供するサービスを本サイトが許可する他の方法で実際に使用したりする場合は、適用可能な法律規定を持って本契約に署名し、本サイトのサービスを使用する能力を持つ自然人、法人、またはその他の組織であることを確認し、承諾してください。「登録に同意する」ボタンをクリックすると、お客様または承認エージェントが本契約の内容に同意し、お客様の代わりに本サイトサービスを登録して使用することができます。",
    protocol26: "登録の目的",
    protocol27: "本サイトへの登録は、法規制に違反したり、本サイトのデジタル資産取引秩序を乱すためではないことを確認し、承諾します。",
    protocol28: "登録プロセス",
    protocol29: "当サイトで有効なメールアドレス、携帯電話番号などの情報を提供することに同意し、当サイトに登録して当サイトサービスを使用することに同意します。当サイトのユーザー登録ページの要件に従って操作します。ご提供または確認いただいたメールボックス、携帯電話番号、または当サイトで許可されている他の方法を使用して、当サイトにログインすることができます。これらの情報の真実性、完全性、正確性に責任を負い、そのために生じる直接的または間接的な損失と不利な結果を負担する必要があります。",
    protocol30: "登録に必要な情報を合法的、完全かつ効果的に提供し、確認した後、当サイトのアカウントとパスワードを取得する権利があります。このサイトのアカウントとパスワードを取得すると、登録に成功したとみなされ、このサイトにログインできます。",
    protocol31: "あなたは、当サイトが送信する当サイトの管理、運営に関連する電子メールおよび/またはメールを受信することに同意します。",
    protocol32: "四、サービス",
    protocol33: "当サイトは、当サイトを通じたデジタル資産取引活動に対してのみネットワーク取引プラットフォームサービスを提供しています。",
    protocol34: "サービス内容",
    protocol35: "あなたは当サイトで各種デジタル資産製品のリアルタイム相場及び取引情報を閲覧する権利があり、また当サイトを通じてデジタル資産取引命令を提出し、デジタル資産取引を完了する権利があります。",
    protocol36: "サービス・ルールこのWebサイトの次のサービス・ルールを遵守することを約束します。",
    protocol37: "法律、法規、規則、および政策要件の規定に従ってください。これには、違法、不法、または他人の権利を侵害する情報の送信または受信、マルチ販売材料またはその他の有害な情報または言論の送信または受信、当サイトの許可なしに当サイトの電子メールヘッダ情報の使用または偽造などが含まれますが、これらに限定されません。",
    protocol38: "法律・法規を遵守し、アカウントおよびログインパスワード、資金パスワード、登録時にバインドされた携帯電話番号、携帯電話に受信された携帯電話の認証コードなどを適切に使用して保管してください。アカウントとログインパスワード、資金パスワード、携帯電話の認証コードを使用した操作と結果については、すべての責任を負う必要があります。お客様の当サイトアカウント、ログインパスワード、資金パスワード、認証コードが第三者によって使用されていないこと、または他のアカウントのセキュリティ上の問題があることを発見した場合は、直ちに有効に当サイトに通知し、当サイトに当サイトアカウントのサービスを一時停止するように要求する必要があります。",
    protocol39: "本サイトでデジタル資産取引を行う際には、デジタル資産取引の正常な進行を悪意を持って妨害し、取引秩序を乱してはならない。いかなる技術手段やその他の方法でも当サイトの正常な運行を妨害したり、他のユーザーが当サイトサービスを使用することを妨害したりすることはできない、事実を捏造するなど、当サイトの評判を悪意的に中傷することはできません。",
    protocol40: "製品ルール",
    protocol41: "取引情報の参照",
    protocol42: "当サイトで取引情報を閲覧する場合は、価格、委託量、手数料、購入または販売の方向など、取引情報に含まれるすべての内容をよく読んでください。取引情報に含まれているすべての内容を完全に受け入れた後、ボタンをクリックして取引を行うことができます。",
    protocol43: "発注の発行",
    protocol44: "取引情報を参照して間違いがないことを確認すると、取引注文を発行できます。",
    protocol45: "取引の詳細の表示",
    protocol46: "アカウントから適切なトランザクションを表示できます。",
    protocol47: "五、当サイトの権利と義務",
    protocol48: "本契約で定められた登録資格を持っていない場合、本サイトはあなたの登録を拒否する権利があり、本サイトはあなたまたはあなたの授権代理人に責任を追及する権利を保留します。また、当サイトは他の場合にも登録を受け入れるかどうかを決定する権利を保持しています。",
    protocol49: "当サイトがアカウント利用者がアカウントの元の登録者ではないことを発見した場合、アカウントの使用を一時停止または終了する権利がある。",
    protocol50: "当サイトが当サイトに展示されている情報に明らかな誤りがあることを発見した場合、当サイトは情報を訂正する権利がある。",
    protocol51: "当サイトは、当サイトのサービスを随時変更、中止または終了する権利を保持しています。当サイトがサービスを変更または中止する権利を行使する場合は、事前に通知する必要はありません。当サイトは当サイトの1つまたは複数のサービスを終了し、当サイトがウェブサイト上で終了公告を発表した日から発効する。",
    protocol52: "六、責任制限及び免責条項",
    protocol53: "いかなる場合においても、私たちは次の事項に責任を負わないことを理解し、同意します。",
    protocol54: "Lo収入損失、",
    protocol55: "取引利益又は契約損失、",
    protocol56: "業務中断による損失、",
    protocol57: "データの破損または損失、",
    protocol58: "私たちは、次のいずれかの状況によってあなたに与えられた損失に対して責任を負わないことを理解し、同意します。",
    protocol59: "具体的な取引には重大な違法行為や違約行為が関与する可能性があります。",
    protocol60: "当サイトでのあなたの行為は違法または不道徳の疑いがあります。",
    protocol61: "私たちが原因ではないその他のすべての本サイトが提供するサービスに関連する損失。",
    protocol62: "第七、協議終了",
    protocol63: "当サイトは本契約の規定に基づいて当サイトのすべてのサービスを終了する権利があり、本契約は当サイトのすべてのサービスが終了した日に終了する。",
    protocol64: "本契約が終了した後、お客様は本サイトに対して、元のサイトアカウントにある情報の保持または開示、お客様または第三者に読んだことも送信したこともない情報の転送など、本サイトに対してサービスの提供を継続したり、他の義務を履行したりすることを要求する権利はありません。",
    protocol65: "本契約の終了は、契約を守る側が違約側に他の責任を負わせることを要求する義務に影響しない。",
    protocol66: "八、情報保護",
    protocol67: "当サイトで別途公表されているプライバシー条項の規定は準拠しています。",
    privacy1: "デルはお客様のデータ保護に取り組んでいます",
    privacy2: "プライバシーに関するデルの声明をご覧ください。",
    privacy3: "このページを作成したのは、プライバシー計画の重要な側面を理解し、プライバシーの権利に関する詳細な情報を理解するためです。",
    privacy4: "Crocodile では、プライバシーとデータの保護に努めています。お客様の個人情報セキュリティは私たちにとって極めて重要であり、厳格な内部ガイドライン、法的要件、業界のベストプラクティスに従って、お客様のデータを安全にし、ライセンス目的だけで使用できるようにします。",
    privacy5: "Crocodile のプライバシーの原則",
    privacy6: "常に透明",
    privacy7: "透明性に関するデルのコミットメントは、データの使用方法と共有方法をいつでもお客様に通知することを意味します。私たちは定期的にこのポータルと私たちのプライバシー声明を更新し、あなたに影響を与える可能性のある変更を常に理解していることを確認します。これにより、データとプライバシーに関する賢明な決定を下すことができます。",
    privacy8: "問責制とコンプライアンス",
    privacy9: "私たちは私たちのプライバシー責任に真剣に対応しています。デルのアプローチは、世界中で適用されているデータ保護に関する法律や規制に完全に適合しています。デルは定期的に監査を行い、最高のデータ保護とプライバシー基準を遵守できるようにプロセスを改善し続けています。私たちの計画は、私たちが運営する複数の司法管区で垂涎の安全性とプライバシー認証を取得しています。",
    privacy10: "データセキュリティ",
    privacy11: "デルは、お客様のプライバシーとセキュリティを優先し、内部アクセスを厳格に管理しながら、データを紛失、乱用、または不正アクセスから保護する強力な措置を実施しています。認証を含む高度な暗号化と厳格なプロトコルにより、データの機密性と完全性を維持できます。",
    privacy12: "データの最小化と目的の制限",
    privacy13: "Crocodile が提供するすべての製品とサービスが特定の目的だけでユーザーデータを収集できるようにするために、強力なデータ最小化管理制御を実装しています。Crocodile データ収集の具体的な合法的なビジネス目的をプライバシー声明に記述しました。",
    privacy14: "ユーザーエンタイトルメントとアクセス",
    privacy15: "私たちはあなたの個人データに対する基本的な権利を認め、維持します。これらの権利の行使を支援するために、Crocodile アプリケーションおよび専用ネットワークフォームを通じて使いやすいツールとメカニズムを提供しています。ここでサポートを要請することができます。司法管区に適用される権利の詳細については、次のリンクのプライバシー宣言を参照してください。権利を行使したい場合は、このページの「プライバシーの行使」セクションを参照してください。",
    privacy16: "プライバシーの設計",
    privacy17: "プライバシーとデータ保護がすべての製品とサービスに組み込まれるようにするための厳格なプロセスを作成しました。デルの専門プライバシーチームは、データ保護設計とデフォルト設定を統合するために、グローバルな基準と規制に適合するように開発者と密接に協力しています。",
    privacy18: "このプライバシーステートメントは、Crocodile プラットフォーム、Webサイト、および部門で展開されているすべての個人データ処理活動に適用されます。",
    privacy19: "お客様がデルのサービスのお客様またはユーザーである場合、このプライバシー宣言は、デルがお客様と合意したものを含みますが、これらに限定されません。",
    privacy20: "お客様がデルのサービスに関連するステークホルダー、お客様、またはユーザーではありませんが、デルのWebサイトを使用している場合は、このプライバシーステートメントもお客様に適用されます。",
    other1: "Crocodile について",
    other2: "Crocodile プライバシーポリシー",
    other3: "Crocodile の概要",
    other4: "7ヶ月前",
    语言: "言語",
    'question1': 'なぜCrocodile Exchangeを選ぶのですか？',
    'answer1': 'Crocodile Exchangeは2021年にカナダで設立され、米国財務省（FinCEN）の規制を受け、MSB（Money Services Business）ライセンスを取得しています。',
    'question2': 'アカウントを登録するにはどうすればよいですか？どのような資料が必要ですか？',
    'answer2': '携帯電話番号だけでアカウント登録が可能です。登録後、KYC（本人確認）を完了する必要があり、身分証明書や運転免許証のアップロードを含む手続きでアカウントの安全性を確保します。',
    'question3': '紹介特典はありますか？友達を招待するにはどうすればよいですか？',
    'answer3': 'すべてのユーザーには独自の招待コードがあります。友達を招待し、初回取引を完了すると、紹介手数料として報酬を受け取ることができ、手数料はリアルタイムで引き出せます。',
    'question4': 'プラットフォームは私の資金をどのように保護していますか？',
    'answer4': '当社はマルチコールドウォレット＋ホットウォレット分離メカニズムを採用しており、ユーザーの資産の大部分はオフラインのコールドウォレットに保管されます。また、プラットフォームにはマルチシグネチャメカニズムとリアルタイムリスク管理システムが備わっており、資金の安全を確保しています。',
    "下载App": "アプリをダウンロード",
    "扫描并下载": "スキャンしてダウンロード",
    "全球": "グローバル",
    "顶尖": "トップクラス",
    "加密货币": "暗号資産",
    "交易平台": "取引プラットフォーム",
    "使用美元买入Bitcoin、Ethereum和多种加密货币": "米ドルでBitcoin、Ethereumや様々な暗号資産を購入",
    "通过加密货币、电汇等多种方式存入资金*": "暗号資産、銀行送金など様々な方法で資金を入金*",
    "業界領先的法遵與資安認證": "業界をリードするコンプライアンスとセキュリティ認証",
    "深受全球 1 億以上用戶信賴": "世界中の1億人以上のユーザーに信頼されています"
}
